import { Calendar } from '@styled-icons/remix-line';

import { useQuery } from 'v3/hooks/useQuery';
import { Col, Container, Row } from 'components/GridSystem';
import Header from 'components/Header';
import FloatPlaidButton from 'components/FloatPlaidButton';
import theme from 'styles/theme';
import * as S from './styles';
import currency from 'currency.js';

const CreditCardSuccess = () => {
  const query = useQuery();
  const name = query.get('name') ?? '';
  const nextPaymentDate = query.get('nextPaymentDate') ?? '';
  const paymentDate = query.get('paymentDate') ?? '';
  const totalPaid = query.get('totalPaid') ? Number(query.get('totalPaid')) : 0;

  const handleClick = () => {
    window.location.href = `?closeWebview=true&name=${name}&totalPaid=${totalPaid}&paymentDate=${paymentDate}&nextPaymentDate=${nextPaymentDate}`;
  };

  return (
    <S.Wrapper>
      <Header variant="primary" />
      <S.WelcomeContainer>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <S.Title>Welcome to the club, {name}! ❤️</S.Title>
            <p>You payment was approved, so now you can start saving.</p>
          </Col>
        </Row>
      </S.WelcomeContainer>
      <S.Main>
        <Container>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <S.PaymentDetails>
                <S.PaymentHeader>
                  <S.HeaderTitle>Payment details</S.HeaderTitle>
                </S.PaymentHeader>
                <S.PaymentItem>
                  <div>
                    <S.ItemTitle>YOU PAID</S.ItemTitle>
                    <S.PaidValue>{currency(totalPaid).format()}</S.PaidValue>
                  </div>
                  <S.DateItem>
                    <Calendar
                      size={12}
                      color={theme.colors.savingsClubBlack900}
                    />
                    <p>{paymentDate}</p>
                  </S.DateItem>
                </S.PaymentItem>
                <S.PaymentItem>
                  <S.ItemTitle>NEXT PAYMENT</S.ItemTitle>
                  <S.DateItem>
                    <Calendar
                      size={12}
                      color={theme.colors.savingsClubBlack900}
                    />
                    <p>{nextPaymentDate}</p>
                  </S.DateItem>
                </S.PaymentItem>
              </S.PaymentDetails>
            </Col>
          </Row>
        </Container>

        <FloatPlaidButton onClick={handleClick} type="submit">
          return to app ›
        </FloatPlaidButton>
      </S.Main>

      <S.Footer showPolicyAndTerms />
    </S.Wrapper>
  );
};

export default CreditCardSuccess;
